var exports = {
  "container": "container__iEMGVO",
  "header": "header__o8SoXr",
  "language": "language__GTKi70",
  "name": "name__HxLHs2",
  "previewCode": "previewCode__hpc1T7",
  "isClipped": "isClipped__KoWnjm",
  "expandIconContainer": "expandIconContainer__1FqyXP",
  "actionsContainer": "actionsContainer__ALtimc",
  "openInNewTabButton": "openInNewTabButton__dDOCv7",
};

__webpack_require__.r(module.exports = exports);
